import React from 'react'
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, getDemoMode } from 'store/storeValtio';
import HelpTitle from 'components/common/HelpTitle';

export default function Registration() {
  console.log('Registration');
  const navigate = useNavigate();
  const currentUser = getCurrentUser();
  const demoMode = getDemoMode();
  console.log('Registration', demoMode);

  // useEffect(() => {
  //   const getUserFromFB = async () => {
  //     console.log("Reg UE getUser: ", currentUser.userId);
  //     await getUserFromFirestore(currentUser.userId)
  //       .then((result) => {
  //         const userFB = result.json();
  //         console.log('App UE result:', userFB);
  //         return userFB;
  //         })
  //       .catch((err) => {
  //         console.log("user not registered", currentUser.userId);
  //         return null;
  //       })
  //   }

  //   const userFB = getUserFromFB(currentUser.userId);
  // });



  function register() {
    navigate('/register');
  }

  return (
    <div className='pt-8 h-full flex flex-col justify-normal items-center text-center font-bold text-2xl bg-blue-200 '>
      <HelpTitle title="Registration" helpSubject="Registration" />
      <div className='w-8/12 flex flex-col justify-center item-center mt-10 text-xl'>
        {!currentUser.registrationId && (
          <div>
            <div className={'mt-2 ml-2 font-semibold text-xl text-center'} >
              Registering your app gives you access to additional features.
            </div>
            <div className='mt-10'>
                <button 
                    onClick={()=>register()}
                    className='rawBtn p-4 border-2 border-black bg-green-300' >
                    Register
                </button>
            </div>
          </div>
        )}
        {(!demoMode && currentUser.registrationId) && (
          <div>
            <div className={'mt-2 ml-2 font-semibold text-xl text-center'} >
              You are alread registered!
              <br />
              {currentUser.registrationId}
            </div>
            <div className='flex justify-center mt-10'>
                <button 
                    onClick={()=>register()}
                    className='rawBtn p-4 border-2 border-black bg-green-300' >
                    Re-Register
                </button>
            </div>
          </div>
        )}
        {demoMode && (
          <div>
          <div className={'mt-2 ml-2 font-semibold text-xl'} >
            Registration not allowed in demo mode!
          </div>
        </div>
        )}
        <div className='flex justify-center mt-10'>
            <button 
                onClick={()=>navigate('/')}
                className='rawBtn p-4 border-2 border-black bg-red-300' >
                Cancel
            </button>
        </div>
      </div>
    </div>
  );

}
